<template>
  <div :class="model.background">
    <div class="inno-carousel container mx-auto mb-12 max-w-screen-xl py-8">
      <InnoCarousel
        v-if="products.length"
        :title="model.title"
        :title-component="model.heading"
        :slides="sortedProducts"
        :options="relatedProductsCarouselOptions"
        :pagination="isMobile"
        :navigation="!isMobile"
      >
        <template #slide="{ slide }">
          <InnoCarouselProductCard v-if="slide" :product="slide" class="mb-6" />
        </template>
      </InnoCarousel>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, computed } from "vue";
import { useProducts, InnoCarouselProductCard } from "@/shared/catalog";

type ProductsSkus = {
  productSku: string;
};

type ProductSkuType = {
  skus?: ProductsSkus[];
  query: string;
  background?: string;
  title?: string;
  heading?: string;
};

interface IProps {
  model: ProductSkuType;
  isMobile?: boolean;
  readOnly?: boolean;
}

const props = defineProps<IProps>();

const productSkus = computed<string[]>(() => props.model.skus?.map((item) => item.productSku) ?? []);

const sortedProducts = computed(() => productSkus.value.map((sku) => products.value.find((p) => p.code === sku)));

const { products, fetchProducts } = useProducts();
const relatedProductsCarouselOptions: ICarouselOptions = {
  spaceBetween: 10,
  slidesPerView: 1,
  simulateTouch: true,
  breakpoints: {
    1024: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1280: {
      slidesPerView: "auto",
      spaceBetween: 10,
      slidesOffsetAfter: 360,
    },
  },
};

onMounted(async () => {
  if (productSkus.value.length) {
    await fetchProducts({ filter: `"SKU":${productSkus.value.toString() as string}` });
  } else {
    await fetchProducts({
      itemsPerPage: 8,
      keyword: props.model.query,
    });
  }
});
</script>
